import React from 'react';
import { Outlet } from 'react-router-dom';

// 用于 /orders/* 裸路径的占位页，仅渲染 Outlet（真正内容由父级 MainLayout
// 中的 OrderDetailPortal Drawer 渲染，避免进入 /orders/detail/:id 时 404/白屏）
export default function DummyCatchAll() {
  return <Outlet />;
}
